export enum NoMembershipsAvailableMessage {
  TEMPORARILY_UNAVAILABLE = 'TEMPORARILY_UNAVAILABLE',
  PRESALES_WINDOW_CLOSED = 'PRESALES_WINDOW_CLOSED',
}
